import { render, staticRenderFns } from "./HcDropdownItem.vue?vue&type=template&id=22f5a298&scoped=true&"
import script from "./HcDropdownItem.vue?vue&type=script&lang=js&"
export * from "./HcDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./HcDropdownItem.vue?vue&type=style&index=0&id=22f5a298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f5a298",
  null
  
)

export default component.exports